// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-layout{\n  height:58px;\n  min-height:58px;\n  width:100%;\n  max-height:58px;\n  background-color:#fff;\n  position:relative;\n  z-index:1;\n  box-shadow:0 2px 3px rgba(0,0,0,.05)\n}\n.header-layout footer{\n  border-width:0\n}\n.header-layout h5{\n  margin:0\n}\n.header-layout p{\n  margin-bottom:0\n}\n.header-layout a:hover{\n  text-decoration:none\n}\n.header-layout a:focus{\n  text-decoration:none;\n  color:inherit\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
